import { getLocale } from '@libs/core';
import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';
import type {
    AccountOrdersSuccessResponse,
    AccountGetOrderErrorResponse,
} from '@libs/common-next';
import type { CustomerOrder } from '@libs/common-node';

type GetOrderParams = {
    orderId: string;
    email?: string | null;
    locale?: string | null;
};

export async function getOrders() {
    const url = CWEA_ENDPOINTS.orders.getOrders;
    return await cweaClient.get<AccountOrdersSuccessResponse[]>(url, {
        withLocale: true,
    });
}

export async function getOrder(options: GetOrderParams) {
    const backupLocale = getLocale();
    const url = CWEA_ENDPOINTS.orders.getOrder({
        ...options,
        locale: options.locale ?? backupLocale,
    });
    return await cweaClient.get<CustomerOrder | AccountGetOrderErrorResponse>(
        url
    );
}
